// @tenorlab/nuxt-dashboard-pro
// file: app/models/shared/dashboardview-css.ts
import { getDistinctCssClasses } from '@tenorlab/vue-dashboard/core'

export const dashboardViewCSS = {
  wrapper: 'relative flex flex-col h-full',

  stickyHeaderWrapper: (isEditing: boolean, overrideTopCss: string = 'top-16') => {
    return getDistinctCssClasses(
      `sticky ${overrideTopCss} right-0 z-40 py-2 flex flex-row items-center gap-2 justify-between w-full`,
      `${isEditing ? 'mb-10' : 'mb-4'}`,
      `bg-body content-body`,
    )
  },

  stickyHeaderInnerWrapper: 'flex items-center gap-2 w-full h-full justify-between',
}

export const appHeaderCSS = {
  wrapper: getDistinctCssClasses(
    'z-49 sticky top-0 inset-x-0 flex-shrink-0 flex',
    // dimensions:
    'h-16',
    // colors:
    'bg-topbar content-topbar',
    // shadow:
    'shadow-[0px_5px_3px_-5px_rgba(0,0,0,0.5)]',
  ),
  logo: 'h-8',
  logoWordsOnly: 'h-8 -ml-6.5 hidden lg:flex',
  innerWrapper1: 'relative flex',
  innerWrapper2: getDistinctCssClasses(
    'relative flex-1 flex justify-end sm:justify-between items-center pl-0 pr-3 sm:pl-2 sm:pr-4 lg:mx-auto',
  ),
}

export const appSidebarCSS = {
  wrapper: getDistinctCssClasses(
    `z-50 flex flex-col grow pt-4 pb-4 overflow-x-hidden overflow-y-auto bg-sidebar content-sidebar bg-opacity-95`,
  ),
  logoWrapper: getDistinctCssClasses(`flex shrink-0 items-center gap-x-2 px-4 cursor-pointer`),
  logoWrapperButton: getDistinctCssClasses(`focus:outline-none flex cursor-pointer`),
  logoSymbolCss: getDistinctCssClasses(`mt-1`),
  logoCss: getDistinctCssClasses(`h-8 w-auto space-x-4`),
  navWrapper: getDistinctCssClasses(`mt-5 flex flex-col justify-between overflow-x-hidden overflow-y-auto`),
  navBottomMenuContainerWrapper: getDistinctCssClasses('fixed bottom-3 flex flex-col gap-2 px-3 w-full'),
}

export const appSidebarMobileCSS = {
  wrapper: getDistinctCssClasses(`fixed inset-y-0 left-0 index-y-0 transition-all duration-150`),
}

export const appSidebarDesktopCSS = {
  wrapperCssClass: (isCollapsed: boolean) => {
    return getDistinctCssClasses(
      'hidden overflow-x-hidden transition-all duration-150',
      'relative lg:flex lg:flex-col lg:fixed lg:inset-y-0',
      isCollapsed ? 'lg:w-14' : 'lg:w-64',
    )
  },
}
